export const attributes = {
  type: 'Type',
  guest: 'Guest',
  account: 'Account',
  user: 'User',
  user_id: 'User Id',
  user_name: 'User name',
  author: 'Author',
  email: 'Email',
  password: 'Password',
  comment: 'Comment',
  information: 'Info',
  passenger: 'Passenger',
  passenger_type: 'Passenger Type',
  area_management: 'Area Management',
  ip_address: 'IP',
  cowell: 'Cowell',

  modifier: 'Modifier',
  create_date: 'Create Date',
  modify_date: 'Modify Date',
  service_name: 'Service',
  function_name: 'Function',

  ok: 'Ok',
  clear: 'Clear',
  cancel: 'Cancel',
  close: 'Close',
  delete: 'Delete',
  delete_off: "Can't Delete",
  delete_selected: 'Delete Selected',
  remove: 'Remove',
  confirm: 'Confirm',
  confirm_delete: 'Are you sure delete?',
  confirm_void: 'Are you sure void?',
  confirm_delete_with_name: 'Are you sure delete <{name}>?',
  confirm_remove: 'Are you sure remove?',
  confirm_deprecated: 'Are you sure deprecated?',
  continue: 'Continue',
  reset: 'Reset',
  select: 'Select',
  selected: 'Selected',
  not_selected: 'Not Selected',
  select_all: 'Select All',
  setting: 'Setting',
  mobile_version: 'Mobile',
  and: 'And',

  display_mode: 'Display Mode',

  today: 'Today',
  yesterday: 'Yesterday',
  this_month: 'This Month',
  last_month: 'Last Month',
  three_month: 'Three Month',
  next_month: 'Next Month',

  weekly: 'Week',
  week: 'Week',
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wen: 'Wednesday',
  thr: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',

  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',

  start_date: 'Start Date',
  start_time: 'Start Time',
  end_date: 'End Date',
  end_time: 'End time',
  date_range: 'Date Range',

  id: 'ID',
  status: 'Status',
  activation_status: 'Status',
  activation_type: 'Type',
  shelve_status: 'Status',
  open_register: 'Open Register',
  version: 'Version',
  sort_drag: 'Sort By Drag',
  sort: 'Order',
  is_menu: 'Is Menu',
  icon: 'Icon',
  logo: 'Logo',
  search: 'Search',
  advance_search: 'Advance Search',
  searching: 'Search...',
  not_found: 'Not Found',
  function: 'Function',
  all: 'All',
  empty: 'Empty',
  enabled: 'Enabled',
  disabled: 'Disabled',
  shelve_on: 'Shelve On',
  shelve_off: 'Shelve Off',
  publish: 'Publish',
  published: 'Published',
  unpublished: 'Unpublished',
  deprecated: 'Deprecated',
  yes: 'Yes',
  no: 'No',
  included: 'Included',
  excluded: 'Excluded',
  want_display: 'Display?',
  display: 'Display',
  not_display: 'Not Display',
  display_expired: 'Display Expired',
  not_display_expired: 'Not Display Expired',
  hide: 'Hide',
  preview: 'Preview',
  cover: 'Cover',

  add: 'Add',
  copy: 'Copy',
  import: 'Import',
  save: 'Save',
  save_as: 'Save as',
  edit: 'Edit',
  update: 'Update',
  restore: 'Restore',
  booking: 'Booking',
  next: 'Next',
  complete: 'Complete',
  data: 'Data',
  update_data: 'Update Data',
  modify: 'Modify',
  transfer: 'Transfer',
  add_succeed: 'Add Succeed',
  update_succeed: 'Update Succeed',
  modify_succeed: 'Modify Succeed',
  approve_succeed: 'Approve Succeed',
  reject_succeed: 'Reject Succeed',
  cancel_succeed: 'Cancel Succeed',
  void_succeed: 'Void Succeed',
  booking_succeed: 'Booking Succeed',
  booking_canceled: 'Booking Canceled',
  booking_cancel_failed: 'Booking Cancel Failed',
  gift_submit: 'Submit',
  gift_submit_succeed: 'Submit Succeed',
  gift_submit_failed: 'Submit Failed',
  update_main_price_succeed: 'Set main price succeed',
  update_main_plan_succeed: 'Set main plan succeed',
  delete_succeed: 'Delete Succeed',
  remove_succeed: 'Remove Succeed',
  deprecate_succeed: 'Deprecate Succeed',
  add_failed: 'Add Failed',
  update_failed: 'Update Failed',
  modify_failed: 'Modify Failed',
  void_failed: 'Void Failed',
  delete_failed: 'Delete Failed',
  remove_failed: 'Remove Failed',
  deprecate_failed: 'Deprecate Failed',
  booking_failed: 'Booking Failed',
  empty_log: 'Empty Log',
  update_cost_data: 'Update Cost Date',
  modify_time: 'Modify Date',
  send_mail: 'Send Mail',

  code: 'Code',
  travel_group_type: 'Type',
  travel_group: 'Travel Group',
  related_groups: 'Related Group',
  group_code: 'Group Code',
  group_name: 'Group Name',
  group_cover: 'Group Cover',
  group_serial: 'Serial',
  group_block: 'Group Block',
  block_name: 'Block Name',
  name: 'Name',
  products_link: 'Cowell Link',
  vat: 'VAT',
  english_name: 'English Name',
  emergency_contact: 'Emergency Contact',
  emergency_phone: 'Emergency Phone',
  title: 'Title',
  display_name: 'Display Name',
  display_level: 'Display Level',
  topic: 'Topic',
  sub_title: 'Sub Title',
  system_name: 'System Name',
  line_id: 'Line ID',
  tel: 'Phone',
  service_tel: 'Service Tel',
  description: 'Description',
  contact_person: 'Contact Person',
  contacts: 'Contacts',
  contact_area: 'Contact Area',
  reservation_phone: 'Reservation Phone',
  address: 'Address',

  main_system: 'Main System',
  sub_system: 'Sub System',

  collaborate: 'Collaborate',
  activities_involved: 'Activities involved',
  collaborate_activity: 'Collaborate Activity',
  collaborate_subsidy_list: 'Subsidy List',
  collaborate_group: 'Collaborate Group',
  collaborate_name: 'Collaborate Name',
  collaborate_group_code: 'Group Code',
  collaborate_common_questions_group: 'Common Questions',
  collaborate_spot_questions_group: 'Spot Questions',
  activity_cover: 'Activity Cover',
  is_fill_order_detail: 'Is Fill Order Detail When Import',
  show_remainder_quantity: 'Show Remainder Quantity',
  show_sign_up_quantity: 'Show Signup Quantity',
  show_quota_free: 'Show Used Free Quota',
  show_quota_free_total: 'Show Free Quota Total',
  show_download_files: 'Show Download Files',
  show_doc_file: 'Show Doc File',
  show_orientation_url: 'Show Orientation Url',
  show_menu_url: 'Show Menu Url',
  show_product_feature: 'Show Product Feature',
  show_total_fee: 'Show Total Fee',
  show_bed_type: 'Show Bed Type Option',
  show_off_items: 'Show Off Items',
  only_show_specify_group: 'Only Show Specify Groups',
  only_view_specify_group: 'Only view Specify Group',
  open_spot: 'Default Open Spot',
  can_cancel_order: 'User can cancel Order',
  download: 'Download',

  area: 'Area',
  subarea: 'Subarea',
  offer_subarea: 'Offer Type',
  all_area: 'All Area',
  all_offer_subarea: 'All Offer Type',
  area_name: 'Area Name',
  area_code: 'Area Code',
  situation: 'Situation',
  situation_types: 'Situation Types',
  situation_action: 'Trigger',
  situation_action_a: 'Order Online',
  situation_action_b: 'Online Consultation',
  situation_remind: 'Deep Style',
  member_role: 'Role',
  member: 'Member',
  manager: 'Manager',
  membership: 'Membership',
  member_status: 'Member Status',
  group_type: 'Group',
  free_quota: 'Free quota',
  max_quota: 'Max quota',
  subsidy: 'Subsidy',
  home_top_show: 'Home Menu Show',
  is_promote: 'Promote',
  is_promote_count: 'Promote Count',
  area_hot: 'Hot',
  hide_price_description: 'Hide Price Description',
  area_min_price: 'Minimum Price',
  area_popup: 'Popup',
  seconds: 'Seconds',
  url: 'Url',
  web_site: 'Web Site',
  fax: 'Fax',
  area_code_perm: 'Area Authority',
  count: 'Count',

  area_region: 'Area Region',

  catalog: 'Catalog',
  catalog_type: 'Catalog Type',
  catalog_code: 'Catalog Code',
  catalog_name: 'Catalog Name',
  catalog_cover: 'Catalog Cover',
  operation_picture: 'Operation Picture',
  operation_mobile_picture: 'Mobile Picture',
  order_email: 'Order Email',
  catalog_is_home: 'Catalog Page Show?',
  catalog_is_sub_home: 'Catalog Sub Page Show?',
  catalog_top_ad: 'Top Ad',
  catalog_bottom_ad: 'Bottom Ad',
  catalog_section: 'Catalog Section',
  catalog_product: 'Product',
  catalog_products: 'Products',
  catalog_product_count: 'Product Count',
  catalog_add_product: 'Add Product',
  selected_catalogs: 'Selected Catalogs',
  sync: 'Sync',
  sync_to_area: 'Sync To Area',

  product_type_graphic: 'Graphic',
  product_type_text: 'Text',

  airline_code: 'Code',

  header: 'Header',
  footer: 'Footer',
  bottom: 'Bottom',
  banner: 'Banner',
  tourist_info: 'Tourist Info',
  travel_info: 'Travel Info',
  has_video: 'Has Video?',
  youtube_id: 'Youtube Video ID',
  video: 'Video',
  share_video: 'Share Videos',

  top_travel: 'Top Travel',
  top_travel_group: 'Top Travel Group',

  region_alias: 'Region Alias',
  area_alias: 'Office Alias',
  department_alias: 'Department Alias',
  section_alias: 'Section Alias',

  product: 'Product',
  product_type: 'Product Type',
  product_code: 'Product Code',
  product_name: 'Product Name',
  product_alias: 'Product Alias',
  product_remark: 'Product Remark',
  product_schedule_brief: 'Product Schedule Brief',
  days: 'Days',
  total_days: 'Total Days',
  day: 'Day',
  operator_remark: 'Operator Remark',
  operator_remark_label: '新網站適用，顯示在團控表中，超過10字截斷。',
  operator_remark_max_length: '(超過10字截斷)',
  product_cover: 'Cover',
  route_picture: 'Route Picture',
  banner_picture: 'Banner Picture',
  airline: 'Airline',
  picture: 'Picture',
  mobile_picture: 'Mobile Picture',
  photo: 'Photo',
  tour_leader: 'Tour Leader',
  tour_leader_introduction: 'Introduction',
  tour_leader_languages: 'Languages',
  tour_leader_countries: 'Countries',
  tour_leader_experience: 'Experience',
  pdf_url: 'PDF file url',
  external_url: 'External url',
  orientation_url: 'Orientation url',
  menu_url: 'Menu url',
  departure_status: 'Departure status',
  departure_early: 'Early',
  departure_noon: 'Noon',
  departure_night: 'Night',

  gift_type: 'Type',
  gift: 'Gift',
  gift_name: 'Name',
  gift_quantity: 'Quantity',
  gift_low_quantity: 'Low Quantity',
  gift_stock: 'Stock',
  gift_current_quantity: 'Quantity',
  gift_stock_company: 'Company Stock',
  gift_stock_vendor: 'Vendor Stock',
  gift_department: 'Department',
  gift_employee: 'Employee',
  gift_user: 'User',
  gift_group: 'Group',
  gift_sales: 'Sales',
  gift_operator: 'Operator',
  gift_consumable: 'Consumable',
  gift_limit_times: 'Repeatable',
  gift_cost: 'Cost',
  gift_unit_cost: 'Unit Cost',
  gift_net_price: 'Net Price',
  gift_sale_price: 'Sale Price',
  gift_repurchase_price: 'Repurchase Price',
  gift_amount: 'Amount',
  gift_dividend_point: 'Point',
  gift_posts: 'Post History',
  gift_posting: 'Posting',
  gift_selected_posting: 'Selected Posting',
  gift_posting_month: 'Posting Month',
  init_quantity: 'Init Quantity',
  init_cost: 'Init Cost',
  init_average_cost: 'Init Average Cost',
  purchase_quantity: 'Purchase Quantity',
  purchase_cost: 'Purchase Cost',
  sales_quantity: 'Sales Quantity',
  sales_cost: 'Sales Cost',
  sales_amount: 'Sales Amount',
  sales_profit: 'Sales Profit',
  adjust_quantity: 'Adjust Quantity',
  adjust_cost: 'Adjust Cost',
  final_quantity: 'Final Quantity',
  final_cost: 'Final Cost',
  average_cost: 'Average Cost',
  gift_purchase_create_again: 'Create Again?',

  gift_purchase_date: 'Purchase Date',
  gift_purchases: 'Purchase History',
  gift_purchase: 'Purchase',
  gift_generate_order: 'Generate Order Number',
  gift_import: 'Import',
  gift_imported: 'Imported',
  gift_void_voucher: 'Void Voucher',
  gift_clone_voucher: 'Clone',
  gift_order_number: 'Order Number',
  gift_order_date: 'Order Date',
  gift_voucher_number: 'Voucher Number',
  gift_voucher_date: 'Voucher Date',

  gift_transfer_management: 'Stock Management',
  gift_transfer_date: 'Transfer Date',
  gift_transfers: 'Transfer History',
  gift_transfer_in: 'Transfer In',
  gift_adjust: 'Adjust',
  gift_transfer_show_void: 'Show Void',
  gift_transfer_import: 'Import',
  gift_transfer_adjust: 'Adjust',
  gift_transfer_quantity: 'Transfer Quantity',
  gift_origin_quantity: 'Origin Quantity',
  gift_final_quantity: 'Final Quantity',
  gift_origin_stock: 'Origin Stock',
  gift_final_stock: 'Final Stock',
  gift_stock_type: 'Stock Type',
  gift_stock_type_company: 'Company',
  gift_stock_type_vendor: 'Vendor',
  gift_modify_type: 'Modify Type',
  gift_modify_type_init: 'Init',
  gift_modify_type_purchase: 'Purchase',
  gift_modify_type_export: 'Export',
  gift_modify_type_import: 'Import',
  gift_modify_type_void: 'Void',
  gift_modify_type_adjust: 'Adjust',

  gift_application: 'Apply',
  gift_application_return: 'Apply Return',
  gift_application_number: 'Apply Number',
  gift_application_date: 'Apply Date',
  gift_application_type: 'Apply Type',
  gift_application_state: 'Apply State',
  gift_application_public: 'Public',
  gift_application_department: 'Department',
  gift_application_request_quantity: 'Request Quantity',
  gift_application_return_quantity: 'Return Quantity',
  gift_application_final_quantity: 'Final Quantity',
  gift_application_repurchase_quantity: 'Repurchase Quantity',
  gift_application_amount: 'Amount',
  gift_application_apply_amount: 'Apply Amount',
  gift_application_return_amount: 'Return Amount',
  gift_application_review_number: 'Review Number',
  gift_application_cancel_number: 'Cancel Number',
  gift_application_return_number: 'Return Number',
  gift_application_remark: 'Remark',

  gift_application_fit: 'FIT',
  gift_application_group: '團體',
  gift_application_point: 'Point',
  gift_application_sale: 'Sale',
  gift_application_redeem: 'Redeem',

  gift_application_new: 'New',
  gift_application_pending: 'Pending',
  gift_application_repurchase: 'Repurchase',
  gift_application_reject: 'Reject',
  gift_application_audit: 'Audit',
  gift_application_approve: 'Approve',
  gift_application_void: 'Void',
  gift_application_lock: 'Lock',
  gift_application_cancel: 'Cancel',

  gift_application_submit_date: 'Submit Date',
  gift_application_review_date: 'Review Date',
  gift_application_void_date: 'Void Date',
  gift_application_cancel_date: 'Cancel Date',

  gift_review: 'Review',
  gift_review_operator: 'Operator',
  gift_review_sales: 'Sales',
  gift_review_reviewer: 'Reviewer',
  gift_review_accountant: 'Accountant',
  gift_review_voider: 'Voider',
  gift_review_amount: 'Amount',
  gift_review_void: 'Void',
  gift_review_cancel: 'Cacnel',
  gift_review_clone: 'Clone',
  gift_review_return: 'Return',
  gift_review_print: 'Print',
  gift_review_reject_reason: 'Reject Reason',
  gift_review_void_reason: 'Void Reason',
  gift_review_return_reason: 'Return Reason',

  gift_review_return_print: 'Print',
  gift_review_return_quantity: 'Return Quantity',
  gift_review_return_total_quantity: 'Return Total Quantity',
  gift_review_return_amount: 'Return Amount',
  gift_review_return_total_amount: 'Return Total Amount',

  gift_updater: 'Updater',
  gift_updated_at: 'Updated Date',

  year: 'Year',
  month: 'Month',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',

  group_status: 'Group status',
  group_ok: 'Ok',
  group_ready: 'Ready',
  group_types: 'Group Type',
  abroad_regular_group: 'Abroad Regular Group',
  cruise_ship_group: 'Cruise Ship Group',
  domestic_group: 'Domestic Group',
  self_organized_group: 'Self Organized Group',
  project_discount_group: 'Project Discount Group',
  pak_group: 'PAK Group',
  price_remark1: 'Price Include',
  price_remark2: 'Price exclude',
  price_remark3: 'Price Note',
  free: 'Free',
  deposit: 'Deposit',
  fee: 'fee',
  adult_fee: 'Adult fee',
  adult_cost: 'Adult fee',
  infant: 'Infant',
  baby_cost: 'Baby cost',
  child_cost: 'Child cost',
  child_fee_bed: 'Child Fee Bed(deduct)',
  child_fee: 'Child Fee(deduct)',
  add_bed_fee: 'Add Bed Fee(deduct)',
  adult_tip: 'Adult Tip',
  infant_tip: 'Infant Tip',
  baby_tip: 'Baby Tip',
  child_tip: 'Child Tip',
  tip_fee: 'Tip fee',
  tip_included: 'Tip included',
  tax_fee: 'Tax fee',
  tax_included: 'Tax included',
  visa_fee: 'Visa fee',
  visa_included: 'Visa included',
  visa_free: 'Visa free',
  hide_price: 'Hide price',
  show_up: "Show 'Starting from'",
  departure_date: 'Departure Date',
  signup_deadline: 'Signup Dead line',
  registration_range: 'Registration Range',
  quantity: 'Quantity',
  child_age: 'Child Age',
  baby_age: 'Baby Age',
  order_modify_time_limit: 'Order Modify Time Limit(Minutes)',
  user_quantity: 'User Quantity',
  user_completed_quantity: 'User Completed',
  signup_quantity: 'Signup Quantity',
  signup_completed_quantity: 'Signup Completed',
  max_quantity: 'Max Quantity',
  remainder_quantity: 'Remainder Quantity',
  fulled: 'Fulled',
  has_fulled: 'Fulled',
  not_fulled: 'not fulled',
  expired: 'Expired',
  has_expired: 'Expired',
  not_expired: 'not expired',
  seo: 'SEO',
  seo_title: 'SEO Title',
  seo_description: 'SEO Description',
  seo_keyword: 'SEO Keyword',
  travel_group_count: 'Group Count',

  schedule: 'Schedule',
  breakfast_desc: 'Breakfast Description',
  launch_desc: 'Launch Description',
  dinner_desc: 'Dinner Description',

  hotel: 'Hotel',
  stay_hotel: 'Hotel',
  hotel_sort: 'Sort',
  show_same: 'Show Same Class',
  schedule_brief: 'Schedule Brief',
  schedule_detail_topic: 'Detail Topic',
  schedule_detail_desc: 'Detail Description',

  honey_moon: 'Honey Moon',
  honey_moon_page: 'Honey Moon Page',
  show_honey_moon: 'Show on Honey Moon',
  join: 'Join',
  joined: 'Joined',
  not_join: 'Not Join',
  show_home: 'Show Home',
  top_banner: 'Top Banner',

  traffic: 'Traffic',
  fly_schedule: 'Fly Schedule',
  fly_no: 'Fly No',
  effect_date: 'Effect Date',
  estimated_days: 'Estimated Days',
  day_sort: 'Sort',
  traffic_direction: 'Direction',
  departure_time: 'Departure Time',
  departure_city: 'Departure City',
  arrive_time: 'Arrive Time',
  arrive_city: 'Arrive City',

  voyage: 'Voyage',
  direction: 'Direction',
  checkin_time: 'Check-In Time',
  gate_close_time: 'Gate Close Time',

  continent_name: 'Continent',

  national_flag: 'National Flag',
  weather_list: 'Weather Setting',
  country: 'Country',
  country_name: 'Country Name',
  country_template: 'Country Template',
  country_flag: 'Country Flag',

  region: 'Region',
  region_name: 'Region Name',

  travel_area: 'Area',
  travel_region: 'Region',
  travel_zone: 'Zone',
  selected_zones: 'Selected Zones',

  city: 'City',
  city_name: 'City Name',
  city_template: 'city Template',
  city_weather: 'City Weather',
  city_gmt: 'Greenwich Mean Time',
  weather_country_list: 'Country List',
  weather_city_list: 'City List',
  selected_cities: 'Selected Cities',

  question: 'Question',
  common_question: 'Signup Questions',
  common_question_option: 'Signup Question Option',
  option: 'Option',
  option_name: 'Option Name',
  text: 'Filling Question',
  spot_question: 'Spot Questions',
  spot: 'Spot',
  note: 'Note',
  feature: 'Feature',
  question_type: 'Type',
  question_select: 'Select',
  question_multi: 'Multi',
  question_fill: 'Fill-in',
  placeholder: 'Placeholder',

  order: 'Order',
  order_no: 'Order No',
  details_free_count: 'Free Persons',
  details_count: 'Persons',
  passengers_count: 'Passengers',
  every_one: 'Every One',
  total_fee: 'Total Fee',
  total_cost: 'Total Cost',
  is_free: 'Free?',
  travel_fee: 'Travel Fee',
  travel_cost: 'Travel Cost',
  commons_cost: 'Discount',
  discount_limit: 'Discount Limit',
  spots_cost: 'Spots Cost',
  gender: 'Gender',
  date_of_birth: 'BirthDate',
  age: 'Age',
  age_type: 'Age Type',
  bed_type: 'Bed Type',
  adult: 'Adult',
  child: 'Child',
  baby: 'Baby',
  identity_number: 'ID',
  nationality: 'Nationality',
  relationship: 'Relationship',
  home_address: 'Home Address',
  passport_number: 'Passport Number',
  passport_expire: 'Passport Expire',
  passport_image: 'Passport Image',
  mobile_phone: 'Phone',
  phone_number: 'Phone',
  company_tel: 'Tel',
  remark: 'Remark',
  signup_status: 'Signup Status',
  signup_completed: 'Completed',
  signup_non_complete: 'Non Complete',

  sales: 'Sales',
  order_date: 'Order Date',
  order_details: 'Details',
  order_designated_sales: 'Designated Sales',
  order_remark: 'Remark',
  order_sales: 'Sales',
  order_origin_sales: 'Origin Sales',
  order_total_fee: 'Total Fee',
  order_total_deposit: 'Total Deposit',
  order_company: 'Company',
  order_add_log: 'Add Record',
  order_process_log: 'Process Log',
  order_process_time: 'Process Time',
  order_process_status: 'Status',
  order_process_description: 'Process Remark',
  order_no_process: 'No Process',
  order_no_sales: 'No Specified',
  order_assign: 'Assign',
  order_assign_times: 'Assign Times',
  order_assign_time: 'Assign Time',
  order_operator: 'Operator',
  order_assign_sales: 'Assign Sales',
  order_process: 'Process',
  order_assign_log: 'Assign Log',
  order_notify_title: 'Order Notify Title',
  order_notify_content: 'Order Notify Content',
  assigned_order: 'Assigned Order',
  assigned: 'Assigned',
  non_assigned: 'Non Assigned',
  receipt_type: 'Receipt Type',
  receipt_title: 'Receipt Title',
  receipt_address: 'Receipt Address',
  tax_id: 'Tax Id',
  payment_options: 'Payment Options',
  payment_amount: 'Payment Amount',
  payment_link: 'Payment Link',
  payment_datetime: 'Payment Datetime',
  payment_card_number: 'Payment Card Number',

  inquiry_no: 'Inquiry No',
  inquiry_detail: 'Inquiry Detail',
  inquiry_remark: 'Inquiry Remark',
  inquiry_date: 'Inquiry Date',
  inquiry_know_fantasy: 'How to know Fantasy',
  inquiry_process: 'Process',
  process: 'Process',

  cowell_group_code: 'Cowell Group Code',

  demand_id: 'Demand No',
  demand_subject: 'Tour Subject',
  demand_items: 'Demand Items',
  demand_date: 'Demand Dates',

  export_fields: 'Export Fields',
  update_items: 'Update Items',

  detail_info: 'Detail Info',
  abs_block: 'Abd Block',
  image_alt: 'Image Alternative',
  picture_upload_size: 'Picture Upload Size(bit)',
  upload_size: 'Upload Size',

  employee_code: 'Employee Code',
  employee: 'Employee',
  depart: 'Depart',
  position: 'Position',
  permission: 'Permission',
  group: 'Group',
  permission_group: 'PermissionGroup',
  company: 'Companies',
  companies: 'Companies',
  all_company: 'All Companies',
  employee_name: 'Employee Name',
  employee_status: 'Status',
  employee_resignation: 'Resignation',
  employee_in_service: 'In Service',
  employee_start_date: 'Arrival Day',
  employee_is_web: 'Process Orders',
  employee_superior: 'Superior',
  jwt_token: 'JWT Token',

  blog_share: 'Blog Share',
  publish_date: 'Publish Date',
  issue_date: 'Issue Date',

  news: 'News',
  news_type: 'Type',
  news_link_type: 'Link',
  news_normal_type: 'Normal',
  news_blog_type: 'Blog',
  news_catalog: 'Catalog',
  news_dates: 'Effect Date',

  blog: 'Blog',
  blog_title: 'Title',
  blog_source: 'Source',
  blog_post: 'Blog Post',
  blog_source_id: 'Source ID',
  blog_source_updated_time: 'Source UpdateAt',
  blog_publish_date: 'Publish Date',
  page_view: 'Views',
  blog_layout: 'Blog Layout',
  right_trips: 'Right Trips',
  full_page: 'Full Page(No Trips)',

  edm: 'EDM',
  edm_type: 'Type',
  edm_link_type: 'Link',
  edm_normal_type: 'Normal',
  edm_issue_date: 'Issue Date',

  subscription: 'Subscription',
  subscriber: 'Subscriber',
  subscription_source: 'Source',
  subscription_time: 'Subscription Time',

  magazine: 'DM',
  magazine_on: 'On',
  magazine_off: 'Off',
  magazine_date: 'Date',
  magazine_page: 'Page',
  magazine_pages: 'Total Page',
  magazine_cover: 'Cover',
  magazine_file: 'PDF',
  magazine_file_path: 'Path',
  magazine_file_name: 'Name',
  magazine_desc: 'Desc',
  magazine_link_list: 'Link',
  magazine_content_list: 'Content',

  offer: 'Offer',
  offer_type: 'Type',
  offer_area_type: 'Area Offer',
  offer_bank_type: 'Bank Offer',
  offer_dates: 'Effect Date',

  leader: 'Leader',
  satisfaction: 'Satisfaction',
  customer: 'Customer',
  customer_name: 'Customer Name',
  head_shot: 'Head Shot',
  content: 'Content',
  expired_info: 'Expired Info',
  lecture: 'Lecture',
  lecture_order: 'Lecture Order',
  acquiring_email: 'Acquiring Email',
  in_charge: 'In Charge',
  know_from: 'Know From',
  signup_no: 'No',
  apply_type: 'Apply Type',
  apply_type_inner: 'Apply Inner',
  apply_type_outer: 'Apply Outer',
  signup_date: 'Signup Date',
  signup_start_date: 'Signup Start',
  signup_end_date: 'Signup End',
  tourism_news: 'Tourism News',
  lecture_apply_type: 'Apply Type',
  lecture_know_fantasy: 'How to know Fantasy',
  lecture_notes: 'Notes',
  questionnaire: 'Questionnaire',
  design_questionnaire: 'Questionnaire',

  plan: 'Plan',

  traveler_type: 'Traveler Types',
  price: 'Price',
  main_price: 'Main Price',
  main_plan: 'Main',
  age_min: 'Min Age',
  age_max: 'Max Age',
  traveler_bed_type: 'Bed Type',
  traveler_bed_type_bed: 'Bed',
  traveler_bed_type_no_bed: 'Not Bed',
  traveler_bed_type_add_bed: 'Add Bed',
  traveler_bed_type_infant: 'infant',

  page_seo_name: 'Page Name',
  page_seo_url: 'URL',
  page_seo_page_title: 'PageTitle',
  page_seo_meta_title: 'MetaTitle',
  page_seo_meta_keyword: 'MetaKeyword',
  page_seo_meta_description: 'MetaDescription',
  page_seo_top_message: 'Top Message',

  attribute: 'Attribute',

  regular: 'Regular',
  pc: 'Computer',
  mobile: 'Mobile',
  link: 'Link',
  confirmed: 'Confirmed',
  passed: 'Passed',
  unconfirmed: 'Unconfirmed',
  connect: 'Connect',

  meeting: 'Meeting',
  meeting_type: 'Type',
  meeting_place_type: 'Place Type',
  meeting_place: 'Place',
  meeting_type_briefing: 'Briefing',
  meeting_type_lesson: 'Lesson',
  meeting_datetime: 'Datetime',
  meeting_start_time: 'Start Time',
  meeting_end_time: 'End Time',
  meeting_place_inner: 'Meeting Room',
  meeting_place_other: 'Other',
  meeting_canceled: 'Meeting Canceled',
  meeting_cancel_failed: 'Meeting Cancel Failed',
  briefing: 'Briefing',
  lesson: 'Lesson',
  place_inner: 'Meeting Room',
  place_other: 'Other',
  notify_type_none: 'None',
  notify_type_all: 'All',
  meeting_employee: 'Employee',
  lecturer: 'Lecturer',
  assistant: 'Assistant',
  meeting_tel: 'Tel',
  meeting_capacity: 'Capacity',
  meeting_quantity: 'Quantity',
  meeting_remainder: 'Remainder',
  meeting_is_full: 'Is Full',
  meeting_is_fulled: 'Is Fulled',
  meeting_is_expired: 'Is Expired',
  meeting_apply: 'Apply',
  meeting_apply_modify: 'Apply Modify',
  meeting_apply_cancel: 'Apply Cancel',
  meeting_signup_deadline: 'Signup Deadline',
  meal_provided: 'Meal',
  material: 'Material',
  none: 'None',

  meeting_room: 'Meeting Room',
  meeting_schedules: 'schedules',
  meeting_room_booking: 'Booking Meeting Room',
  meeting_room_booking_single: 'One Time',
  meeting_room_booking_period: 'Period',
  meeting_room_booking_modify: 'Modify Meeting',
  meeting_schedule_title: 'Meeting Title',
  meeting_schedule_desc: 'Description',
  meeting_schedule_employee: 'Employee',
  meeting_schedule_tel: 'Tel',
  meeting_schedule_extension_number: 'Extension Number',
  meeting_schedule_date_range: 'Date Range',
  meeting_schedule_datetime: 'Date & Time',
  meeting_schedule_weekday: 'Weekday',
  meeting_schedule_start_time: 'Start Time',
  meeting_schedule_end_time: 'End Time',
  meeting_schedule_notify_type: 'Notify Type',
  meeting_schedule_notify_target: 'Notify Target',
  meeting_schedule_notify_type_none: 'None',
  meeting_schedule_notify_type_all: 'All Employee',
  meeting_schedule_notify_type_specify: 'Specify Targets',

  complaint: 'Complaint',
  complaint_number: 'Complaint Number',
  complainant: 'Complainant',
  complaint_name: 'Name',
  complaint_tel: 'Tel',
  complaint_email: 'Email',
  complaint_line: 'LINE/Messenger/Google Name',
  complaint_description: 'Complaint Description',
  complaint_channel: 'Complaint Channel',
  complaint_initial_contact_date: 'Initial Contact Date',
  complaint_last_contact_date: 'Last Contact Date',
  customer_service_agent: 'Customer Service Agent',
  origin_customer_service_agent: 'Origin Customer Service Agent',
  product_manager: 'Product Manager',
  product_area: 'Product Area',
  origin_product_manager: 'Origin Product Manager',
  origin_product_area: 'Origin Product Area',
  personnel: 'Personnel',
  handler: 'Handler',

  publication_demand: 'Publication Demand',

  bank: 'Bank',
  bank_number: 'Bank Number',
  branch_name: 'Branch Name',
  short_name: 'Short Name',
  account_name: 'Account Name',
  account_number: 'Account Number',
  business_number: 'Business Number',

  ga: {
    pagePath: 'PagePath',
    pageviews: 'Page Views',
    uniquePageviews: 'Unique Page Views'
  }
}

export const message = {
  my_profile: 'My Profile',
  login: 'Log In',
  logout: 'Logout',
  login_success: 'Login Success',
  login_employee: 'Login Employee',
  login_date: 'Login Date',
  login_system: 'Login System',

  word_limit: '({0} words)',
  please_input: 'Please input',
  please_input_: 'Please input {0}',
  please_select: 'Please select',
  please_select_: 'Please select {0}',
  please_select_file: 'Please select file',
  please_select_picture: 'Please select picture',
  please_input_account: 'Please Input Account',
  please_input_password: 'Please Input Password',
  please_input_product_code: 'Please Input Product Code',
  please_input_group_code: 'Please Input Group Code',
  please_input_common_questions_group_code:
    'Please Input Group Code For Clone Common Questions',
  please_input_spot_questions_group_code:
    'Please Input Group Code For Clone Spot Questions',
  select: 'Select',
  upload_logo: 'Upload Logo',
  refresh: 'Refresh',

  lastWeek: 'Last Week',

  select_locales: 'Language',

  fantasy_backend: 'FantasyTours Backend',
  fantasy_system: 'FantasyTours Management System',
  tour_control: 'Tour Control',
  tour_control_table: 'Tour Control Table',

  fetch_failed: 'Fetch {0} Failed',

  select_fields: 'Select fields',
  rename_fields: 'Rename fields',
  export: 'Export',
  export_reports: 'Export Report',
  export_traveler_reports: 'Export Report',
  export_all_reports: 'Export Detail Report',
  export_activity: 'Export Status',

  invalid_parameter: 'Invalid Parameter',

  confirm_close: 'Modified not save, sure to close？',
  confirm_empty_traveler_types: 'Are you sure not setting traveler types?',
  confirm_empty_plans: 'Are you sure not setting plans?',
  can_not_delete_main_price: 'Can Not Delete Main Price1',
  can_not_delete_last_plan: 'Can Not Delete Last Plan!',

  confirm_approve_gift_review: 'Confirm Approve {0}？',
  confirm_reject_gift_review: 'Confirm Reject {0}？',
  confirm_void_gift_review: 'Confirm Void {0}？',
  confirm_cancel_gift_review: 'Confirm Cancel？',
  please_input_gift_review_reject_reason: 'Please Input Reject Reason',
  please_input_gift_review_void_reason: 'Please Input Void Reason',
  please_input_gift_review_cancel_number: 'Please Input Cancel Number',
  please_input_gift_review_cancel_date: 'Please Input Cancel Date'
}

export const validation = {
  welcome_back: 'Welcome back, {username}.',
  required: '{attribute} should be filled in.',
  requiredIf: '{attribute} should be filled in.',
  required_select: 'Please select {attribute}',
  required_choose: 'Please choose {attribute}',
  required_check: 'Please check {attribute}',
  required_account:
    'Be sure to fill {attribute}(it will be used as a login account)',

  minLength: 'The {attribute} field must be at least {mix} characters',
  maxLength: 'The {attribute} field may not be greater than {mix} characters',
  minValue: 'The {attribute} field must be {min} or more',
  maxValue: 'The {attribute} field must be {max} or less',
  between: 'The {attribute} field must be between {min} and {max}',
  alpha: 'The {attribute} field may only contain alphabetic characters',
  alphaNum: 'The {attribute} field may only contain alpha-numeric characters',
  numeric: '{attribute} may only contain numeric characters',
  integer: 'The {attribute} field must be an integer',
  decimal: 'The {attribute} field must be an decimal',
  email: 'The {attribute} field must be a valid email',

  confirm_cancel_meeting: 'Are you sure cancel?',
  confirm_cancel_meeting_: 'Are you sure cancel「{name}」?'
}

export default {
  attributes,
  message,
  validation
}
